import { CalendarDay } from "./calendarday";
import { CalendarLotDay } from "./calendarlotday";
import { ChangeTracked } from "./changetracked";

export class CalendarLot {
    marketCalendar?: CalendarDay[];
    lotCalendar?: CalendarLotDay[] & ChangeTracked<CalendarLotDay[]>;
}
